"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var context_proxy_exports = {};
__export(context_proxy_exports, {
  createMeasureContextProxy: () => createMeasureContextProxy
});
module.exports = __toCommonJS(context_proxy_exports);
function createMeasureContextProxy(first, ...contexts) {
  return createProxy([first, ...contexts]);
}
__name(createMeasureContextProxy, "createMeasureContextProxy");
function createProxy(contexts, parent) {
  const operations = {
    with(name, params, op, fullParams, opt) {
      const children = [];
      const run = /* @__PURE__ */ __name((index) => contexts[index].with(
        name,
        params,
        (child) => {
          children.push(child);
          return index === contexts.length - 1 ? op(createProxy(children, proxy)) : run(index + 1);
        },
        fullParams,
        index === 0 ? opt : { ...opt, log: false }
      ), "run");
      return run(0);
    },
    withSync(name, params, op, fullParams, opt) {
      const children = [];
      const run = /* @__PURE__ */ __name((index) => contexts[index].withSync(
        name,
        params,
        (child) => {
          children.push(child);
          return index === contexts.length - 1 ? op(createProxy(children, proxy)) : run(index + 1);
        },
        fullParams,
        index === 0 ? opt : { ...opt, log: false }
      ), "run");
      return run(0);
    },
    newChild(name, params, opt) {
      return createProxy(
        contexts.map((ctx) => ctx.newChild(name, params, opt)),
        proxy
      );
    },
    end(value) {
      for (const ctx of contexts) {
        ctx.end(value);
      }
    },
    counter(name, value) {
      for (const ctx of contexts) {
        ctx.counter(name, value);
      }
    },
    gauge(name, value) {
      for (const ctx of contexts) {
        ctx.gauge(name, value);
      }
    }
  };
  const proxy = new Proxy(contexts[0], {
    get(target, property) {
      if (property === "with" || property === "withSync" || property === "newChild" || property === "end" || property === "counter" || property === "gauge") {
        return operations[property];
      }
      if (property === "parent" && parent !== void 0) {
        return parent;
      }
      const value = Reflect.get(target, property, target);
      return typeof value === "function" ? value.bind(target) : value;
    },
    set(target, property, value) {
      if (property === "contextData" || property === "id") {
        return contexts.every((ctx) => Reflect.set(ctx, property, value, ctx));
      }
      return Reflect.set(target, property, value, target);
    }
  });
  return proxy;
}
__name(createProxy, "createProxy");
//# sourceMappingURL=context-proxy.js.map
